import React from 'react';
import { useHistory } from 'react-router-dom';
import '../dashboard/css/Article1.css';
import blogImage from '../dashboard/assets/Article.avif';
import blog1 from '../dashboard/assets/Articles2.png';

const Article2 = () => {
  const history = useHistory();

  return (
    <div className="rsh-blog-section">
      {/* Hero */}
      <div
        className="rsh-blog-hero"
        style={{ backgroundImage: `url(${blogImage})` }}
      >
        <div className="rsh-blog-overlay">
          <h1 className="rsh-blog-title">Articles</h1>
          <p className="rsh-breadcrumb">
            <span onClick={() => history.push('/')}>Home</span> / Articles
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="rsh-blog-container">
        <h2 className="rsh-section-title">
          Top Home Tutors in Vadodara: Area-Wise Guide for School Students
        </h2>

        <div className="rsh-published-badge">
          Published on: 02 January 2026
        </div>

        <img
          src={blog1}
          alt="Top Home Tutors in Vadodara"
          className="rsh-blog-detail-img"
        />

        <div className="rsh-blog-detail-content">
          <p className="intro-text">
            Vadodara has rapidly grown into one of Gujarat’s leading education
            hubs. With reputed schools, competitive boards, and increasing
            academic pressure, the demand for experienced home tutors in
            Vadodara has increased significantly.
          </p>

          <p>
            Parents today prefer home tuition because it offers personalized
            attention, flexible timings, and focused learning. This detailed
            area-wise guide will help parents and students identify the best
            locations in Vadodara to find reliable and qualified home tutors.
          </p>

          {/* WHY HOME TUITION */}
          <div className="info-box">
            <h3>Why Home Tuition Is Popular in Vadodara</h3>
            <p>
              Home tuition has become a preferred choice among Vadodara parents
              due to its student-centric approach and measurable academic
              results.
            </p>
            <ul>
              <li>One-to-one attention for better concept clarity</li>
              <li>Customized teaching pace based on student ability</li>
              <li>Flexible scheduling for school and exam preparation</li>
              <li>Safe and comfortable learning environment at home</li>
            </ul>
          </div>

          {/* AREA WISE */}
          <div className="info-box">
            <h3>Top Areas in Vadodara to Find Home Tutors</h3>
            <p>
              Home tutors are available across major residential and educational
              zones in Vadodara. Some areas have higher availability due to
              student density and proximity to schools.
            </p>
            <ul>
              <li><strong>Manjalpur:</strong> High demand for CBSE & Gujarat Board tutors</li>
              <li><strong>Alkapuri:</strong> Preferred for senior classes & science streams</li>
              <li><strong>Karelibaug:</strong> Popular for classes 6–10 home tuition</li>
              <li><strong>Gotri & Vasna:</strong> Growing demand for competitive exam tutors</li>
              <li><strong>Akota:</strong> English, Maths, and board exam specialists</li>
            </ul>
          </div>

          {/* QUALIFICATION */}
          <div className="info-box">
            <h3>What Qualifications Should Home Tutors Have?</h3>
            <p>
              Choosing a qualified tutor is essential to ensure consistent
              academic improvement and exam readiness.
            </p>
            <ul>
              <li>Strong subject knowledge with academic credentials</li>
              <li>Experience with CBSE, ICSE, or Gujarat Board syllabus</li>
              <li>Proven teaching experience with school students</li>
              <li>Positive feedback from Vadodara parents</li>
            </ul>
          </div>

          {/* TABLE 1 */}
          <h3 className="table-title">
            Home Tuition vs Coaching Institutes in Vadodara
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Coaching Institute</th>
                  <th>Home Tuition</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Class Size</td>
                  <td>20–50 students</td>
                  <td>1-on-1 or small group</td>
                </tr>
                <tr>
                  <td>Personal Attention</td>
                  <td>Limited</td>
                  <td>Very High</td>
                </tr>
                <tr>
                  <td>Learning Pace</td>
                  <td>Fixed</td>
                  <td>Customized</td>
                </tr>
                <tr>
                  <td>Travel Requirement</td>
                  <td>Yes</td>
                  <td>No</td>
                </tr>
                <tr>
                  <td>Parent Monitoring</td>
                  <td>Low</td>
                  <td>High</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* TABLE 2 */}
          <h3 className="table-title">
            Average Home Tuition Fees in Vadodara (Per Month)
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Class / Exam</th>
                  <th>Home Tuition Fees (₹)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Class 6–8</td>
                  <td>2,000 – 5,000</td>
                </tr>
                <tr>
                  <td>Class 9–10</td>
                  <td>3,000 – 6,000</td>
                </tr>
                <tr>
                  <td>Class 11–12 (Science)</td>
                  <td>4,000 – 10,000</td>
                </tr>
                <tr>
                  <td>JEE / NEET</td>
                  <td>8,000 – 20,000</td>
                </tr>
                <tr>
                  <td>Spoken English / IELTS</td>
                  <td>6,000 – 12,000</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* FINAL */}
          <div className="info-box">
            <h3>Final Thoughts</h3>
            <p>
              Selecting the right home tutor in Vadodara depends on the student’s
              academic needs, location, and learning style. Area-wise selection
              helps parents find experienced tutors quickly while ensuring
              better academic outcomes.
            </p>
          </div>

          <div className="rsh-back-btn-wrapper">
            <button
              className="rsh-back-btn"
              onClick={() => history.push('/index')}
            >
              Go Back To Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article2;